import { observable, action } from 'mobx';
import { ITheme } from '../../../interfaces/ITheme';
import { Helper } from '../../../Helper';

export class ThemeStore {
  @observable public environment: "Development" | "Test" | "Production";
  @observable public tenant: string;
  @observable public token: string;

  @observable public themes: ITheme[];
  @observable public themeSelected: ITheme;

  @observable public loading: boolean;
  @observable public saving: boolean;
  @observable public deleting: boolean;

  @observable public isAddMode: boolean;
  @observable public isDeleteMode: boolean;

  @observable public showEditInfoText: boolean;

  @action public addTheme(theme: ITheme): void {
    this.isAddMode = true;
    this.showEditInfoText = false;
    this.themeSelected = theme;
  }

  @action public editTheme(theme: ITheme): void {
    this.isAddMode = false;
    this.showEditInfoText = true;
    Helper.setLocalStorage("IntraActive_Theme_Selected", JSON.stringify(theme));
    this.themeSelected = theme;
  }

  @action public openTheme(theme: ITheme): void {
    this.isAddMode = false;
    this.showEditInfoText = true;
    Helper.setLocalStorage("IntraActive_Theme_Selected", JSON.stringify(theme));
    this.themeSelected = theme;
  }

  @action public deleteTheme(theme: ITheme): void {
    this.isAddMode = false;
    this.isDeleteMode = true;
    this.showEditInfoText = false;
    this.themeSelected = theme;
  }

  @action public resetTheme(): void {
    const originalTheme: ITheme = JSON.parse(localStorage.getItem("IntraActive_Theme_Selected"));
    this.themes.forEach((theme, index) => {
      if (theme.Name == originalTheme.Name) {
        this.themes[index] = originalTheme;
      }
    });
    localStorage.removeItem("IntraActive_Theme_Selected");
  }

  @action public isThemeChanged(): boolean {
    if (this.isAddMode) {
      return true;
    }
    // Check original version for changes
    const originalTheme: ITheme = JSON.parse(localStorage.getItem("IntraActive_Theme_Selected"));
    if (originalTheme) {
      if (originalTheme.Name != this.themeSelected.Name) {
        return true;
      }
      if (originalTheme.IsInverted != this.themeSelected.IsInverted) {
        return true;
      }
      for (let key in originalTheme.Palette) {
        if (originalTheme.Palette[key] != this.themeSelected.Palette[key]) {
          return true;
        }
      }
    }
    return false;
  }
}